var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.reference != null)?_c('el-drawer',_vm._b({style:(_vm.styleModifier),attrs:{"visible":_vm.visible},on:{"update:visible":_vm.handleVisibleChange}},'el-drawer',_vm.inheritedProperties,false),[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }